import AllCauseMenu from "./UtilItems/UtilAllCause";
import HCMMenu from "./UtilItems/UtilHCM";

interface UtilMenuProps {
  setDisplayValue: (val: number) => void;
  displayValue: number;
  clear: boolean;
  setClear: (val: boolean) => void;
  setIsFiltersOpen?: () => void;
}

const UtilMenu: React.FC<UtilMenuProps> = ({
  setDisplayValue,
  displayValue,
  setClear,
  clear,
  setIsFiltersOpen,
}) => {
  return (
    <>
      {" "}
      <div className="collapse collapse-plus  rounded-sm  ">
        <input type="checkbox" name="my-accordion-2" />
        <div
          className="collapse-title text-base font-medium"
          style={{position: "static"}}>
          <div className="ml-5 text-nowrap text-valmidnight">All-Cause</div>
        </div>
        <div className="collapse-content">
          <p>
            {" "}
            <AllCauseMenu
              setDisplayValue={setDisplayValue}
              displayValue={displayValue}
              setClear={setClear}
              clear={clear}
              setIsFiltersOpen={setIsFiltersOpen}></AllCauseMenu>
          </p>
        </div>
      </div>
      <div className="collapse collapse-plus  rounded-sm  ">
        <input type="checkbox" name="my-accordion-2" />
        <div
          className="collapse-title text-base font-medium"
          style={{position: "static"}}>
          <div className="ml-5 text-nowrap text-valmidnight">HCM </div>
        </div>
        <div className="collapse-content">
          <p>
            {" "}
            <HCMMenu
              setDisplayValue={setDisplayValue}
              displayValue={displayValue}
              setClear={setClear}
              clear={clear}
              setIsFiltersOpen={setIsFiltersOpen}></HCMMenu>
          </p>
        </div>
      </div>
    </>
  );
};

export default UtilMenu;
